export default __webpack_public_path__ + "static/media/unsplash_image3.0850c66a.png";